/**
 * Фільтр контактних посилань — ОДИН на весь застосунок (owner 2026-08-31:
 * «в контактах дві кнопки — посилання на канал»).
 *
 * Прибираємо те, що не є контактом замовника:
 *  • інвайт у канал/групу — `t.me/+hash`, `joinchat`;
 *  • голе посилання на канал — `t.me/name` без шляху (підпис джерела).
 * Посилання на конкретний пост (`t.me/name/123`) лишається — це сама вакансія.
 */

// Owner 2026-08-31: «ми НЕ витягуємо як контакт посилання на телеграм» —
// ані канал, ані інвайт, ані t.me/m/…. Контакт у телеграмі — це @username,
// він приходить окремим полем `telegrams`.
const TELEGRAM = /(?:^|\/\/)(?:t|telegram)\.me\//i;

export function isContactLink(url: string): boolean {
  const u = (url || "").trim();
  if (!u) return false;
  return !TELEGRAM.test(u);
}

export function filterContactLinks(urls: string[] | undefined | null): string[] {
  return (urls ?? []).filter(isContactLink);
}
